// src/helpers.ts
import ReactDOM from "react-dom";
var isBelowReact18 = +ReactDOM.version.split(".")[0] < 18;
var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : (callback) => Promise.resolve(null).then(callback);
var updateTasks = [];
var createStateChangeHandler = (updateTask) => {
  if (!isBelowReact18) {
    return updateTask;
  }
  return function() {
    if (!updateTasks.length && ReactDOM.unstable_batchedUpdates) {
      scheduleMicrotask(() => {
        ReactDOM.unstable_batchedUpdates(() => {
          updateTasks.forEach((updateTask2) => updateTask2());
          updateTasks = [];
        });
      });
    }
    updateTasks.push(updateTask.bind(null, ...arguments));
  };
};
var subStateChange = (EmitterInstance, storeInstance) => {
  EmitterInstance.on("status", createStateChangeHandler((status) => storeInstance.setState({ status })));
  EmitterInstance.on("accounts", createStateChangeHandler((accounts) => storeInstance.setState({ accounts })));
  EmitterInstance.on("chainId", createStateChangeHandler((chainId) => storeInstance.setState({ chainId })));
  EmitterInstance.on("balance", createStateChangeHandler((balance) => storeInstance.setState({ balance })));
};
var selectors = {
  status: (state) => state.status,
  chainId: (state) => state.chainId,
  balance: (state) => state.balance,
  accounts: (state) => state.accounts,
  account: (state) => state.accounts?.[0]
};
export {
  selectors,
  subStateChange
};
